import { endpoint } from "@services/api.services";
import { TableCard } from "@ui/internal/components/card";
import { usePathname } from "@utils/hook/index.hook";
import { QueryData } from "@utils/interface/index.interface";
import { useListData } from "@utils/query/index.query";
import React from "react";
import { useSearchParams } from "react-router";
import { ColumnList } from "./column/index.column";
import CricketTeamForm from "./form/index.form";
import { useMetaStore } from "@utils/states/index.state";
type Props = {};
const index: React.FC<Props> = ({}) => {
  const [searchParams] = useSearchParams();
  const pathname = usePathname();

  const columns = ColumnList();
  const { search, date } = useMetaStore();
  /* ================================================= api calls logic ================================================= */
  const { data, refetch, isPending } = useListData<QueryData<any>>({
    params: {
      page: searchParams.get("tpage") || 1,
      size: searchParams.get("per") || 10,
      ordering: searchParams.get("ordering") || "order",
      search: search,
    },
    endpoint: endpoint["cricket-teams"],
    key: `${pathname}-listing`,
    window: true,
  });
  return (
    <>
      <TableCard
        bulkActions
        table_content={{
          mode: "default",
          type: "manage-teams",
        }}
        orientationPosition={false}
        endpoint={endpoint["cricket-teams"]}
        refetch={refetch}
        isPending={isPending}
        columns={columns}
        sortableFilter={{
          search: search,
        }}
        rows={data?.data?.results ?? []}
        count={data?.data?.count ?? 10}
        form={<CricketTeamForm />}
      />
    </>
  );
};

export default index;
